// import React, { useState } from "react";
// import Breadcrumbs from "../../components/Common/Breadcrumb";
// import { Row, Col } from "reactstrap";
// import { toast } from "react-toastify";
// import { baseURL, formatDate, getRecords } from "../../services/api.service";
// import TextInput from "../../custom/components/Text-Input/TextInput";
// import SelectInput from "../../custom/components/Select-Input/SelectInput";
// import { loaderOverlay } from "../../Style/loaderOverly";
// import { LoaderCreatePage } from "../Loader/Loader";
// import { Download } from "react-feather";

// const DispatchReport = () => {
//   const [filters, setFilters] = useState({
//     fromDate: "",
//     toDate: "",
//     filterType: null,
//   });

//   const [errors, setErrors] = useState({});
//   const [loadingData, setLoadingData] = useState(false);
//   const [reportData, setReportData] = useState([]);
//   const [showReport, setShowReport] = useState(false);

//   const filterOptions = [
//     { value: "DISPATCHED", label: "Dispatched" },
//     { value: "PENDING", label: "Pending" },
//     { value: "TODAY REPAIRED", label: "Today Repaired" },
//     { value: "BY ENGINEER", label: "By Engineer" },
//     { value: "CUSTOM RANGE", label: "Custom Range" },
//   ];

//   const handleFilterTypeSelect = (option) => {
//     setShowReport(false);

//     const today = new Date().toISOString().split("T")[0];

//     if (option?.value === "TODAY REPAIRED") {
//       setFilters((prev) => ({
//         ...prev,
//         filterType: option,
//         fromDate: today,
//         toDate: today,
//       }));
//     } else {
//       setFilters((prev) => ({
//         ...prev,
//         filterType: option,
//       }));
//     }

//     setErrors((prev) => ({
//       ...prev,
//       filterType: null,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setShowReport(false);

//     const newErrors = {};
//     if (!filters.fromDate) newErrors.fromDate = "From date is required";
//     if (!filters.toDate) newErrors.toDate = "To date is required";
//     if (!filters.filterType) newErrors.filterType = "Filter type is required";

//     if (Object.keys(newErrors).length) {
//       setErrors(newErrors);
//       return;
//     }

//     setLoadingData(true);

//     try {
//       const payload = {
//         filterType: filters.filterType.value,
//         from: filters.fromDate,
//         to: filters.toDate,
//       };

//       const res = await getRecords(payload, "/jobCardReport");
//       setReportData(res?.data || []);
//       setShowReport(true);
//     } catch {
//       toast.error("Failed to load report");
//     } finally {
//       setLoadingData(false);
//     }
//   };

//   const exportToExcel = async () => {
//     try {
//       const response = await fetch(`${baseURL}api/export/job-card-report`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           filterType: filters.filterType.value,
//           from: filters.fromDate,
//           to: filters.toDate,
//         }),
//       });

//       const blob = await response.blob();
//       const downloadUrl = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = downloadUrl;
//       a.download = "dispatch_report.xlsx";
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(downloadUrl);
//     } catch {
//       toast.error("Export failed");
//     }
//   };

//   const getDateByFilter = (row) => {
//     const type = filters?.filterType?.value;

//     switch (type) {
//       case "TODAY REPAIRED":
//         return row?.repair_completed_date;
//       case "DISPATCHED":
//         return row?.dispatched_date;
//       case "PENDING":
//         return row?.createdAt;
//       case "BY ENGINEER":
//         return row?.repair_completed_date;
//       default:
//         return row?.createdAt;
//     }
//   };

//   return (
//     <div className="page-content">
//       <Breadcrumbs title="Dispatch Report" breadcrumbItems={[]} />

//       <div className="card p-4 mb-3">
//         <form onSubmit={handleSubmit}>
//           <Row>
//              <Col md={3}>
//               <SelectInput
//                 label="Filter Type"
//                 options={filterOptions}
//                 value={filters.filterType}
//                 onSelect={handleFilterTypeSelect}
//                 placeholder="Select Filter Type"
//                 customError={errors.filterType}
//               />
//             </Col>
//             <Col md={3}>
//               <TextInput
//                 label="From Date"
//                 type="date"
//                 value={filters.fromDate}
//                 readOnly={filters?.filterType?.value === "TODAY REPAIRED"}
//                 onChange={(e) => {
//                   const newFrom = e.target.value;
//                   setShowReport(false);

//                   setFilters({
//                     ...filters,
//                     fromDate: newFrom,
//                     toDate:
//                       filters.toDate && filters.toDate < newFrom
//                         ? newFrom
//                         : filters.toDate,
//                   });

//                   setErrors((prev) => ({ ...prev, fromDate: null }));
//                 }}
//                 customError={errors.fromDate}
//               />
//             </Col>

//             <Col md={3}>
//               <TextInput
//                 label="To Date"
//                 type="date"
//                 value={filters.toDate}
//                 min={filters.fromDate}
//                 readOnly={filters?.filterType?.value === "TODAY REPAIRED"}
//                 onChange={(e) => {
//                   setShowReport(false);
//                   setFilters({ ...filters, toDate: e.target.value });
//                   setErrors((prev) => ({ ...prev, toDate: null }));
//                 }}
//                 customError={errors.toDate}
//               />
//             </Col>

//             <Col md={3} className="d-flex align-items-end">
//               <button type="submit" className="btn btn-primary">
//                 GO
//               </button>
//             </Col>
//           </Row>
//         </form>
//       </div>

//       {loadingData && (
//         <div style={loaderOverlay}>
//           <LoaderCreatePage />
//         </div>
//       )}

//       {showReport && (
//         <div className="card mt-4 p-3">
//           <Row className="mt-2">
//             <Col style={{ display: "flex", justifyContent: "space-between" }}>
//               <h5 className="card-header">Dispatch Details</h5>

//               <button
//                 type="button"
//                 onClick={exportToExcel}
//                 className="btn btn-success d-flex align-items-center gap-2"
//                 style={{ fontSize: "13px", marginTop: "10px" }}
//               >
//                 <Download size={16} />
//                 Export To Excel
//               </button>
//             </Col>

//             <div className="table mt-2" style={{ maxHeight: "450px", overflowY: "auto" }}>
//              <table className="table table-bordered fw-bold">
//   <thead
//     style={{
//       backgroundColor: "#f9992d",
//       position: "sticky",
//       top: 0,
//       // zIndex: 2,
//     }}
//   >
//     <tr>
//       <th>Sr No</th>
//             <th>Item Name</th>

//       <th>Job Card</th>
//       <th>Item Serial No</th>
//       <th>Status</th>
//       <th>Engineer Name</th>
//       <th>
//         {filters?.filterType?.value === "TODAY REPAIRED"
//           ? "Repair Completed Date"
//           : filters?.filterType?.value === "DISPATCHED"
//           ? "Dispatch Date"
//           : "Created Date"}
//       </th>
//     </tr>
//   </thead>

//                 <tbody>
//                   {reportData.length === 0 && (
//                     <tr>
//                       <td colSpan="6" className="text-center text-muted">
//  There are no records to display                      </td>
//                     </tr>
//                   )}

//                   {reportData.map((row, index) => (
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                                             <td>{row?.intake?.material?.name}</td>

//                       <td>{row?.job_card_no}</td>
//                       <td>{row?.intake?.material_serial_no}</td>
//                       <td>{row?.status}</td>
//                       <td>{row?.technician?.full_name}</td>
//                       <td>{formatDate(getDateByFilter(row))}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>

//             </div>
//           </Row>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DispatchReport;

import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Row, Col } from "reactstrap";
import { toast } from "react-toastify";
import {
  apiUrl,
  baseURL,
  formatDate,
  getRecords,
} from "../../services/api.service";
import TextInput from "../../custom/components/Text-Input/TextInput";
import SelectInput from "../../custom/components/Select-Input/SelectInput";
import MultiSelectInput from "../../custom/components/MultiSelect-Input/MultiSelectInput";
import { loaderOverlay } from "../../Style/loaderOverly";
import { LoaderCreatePage } from "../Loader/Loader";
import { Download } from "react-feather";
import formatDateTime from "../../custom/Utils/formatDateTime";
import useListFilters from "../../custom/Utils/UseListFiltersUtils";
import {
  ITEM_GMDS_CODE_FILTER,
  ITEM_DESCRIPTION_FILTER,
  DISPATCHED_SERIAL_NO_FILTER,
} from "../../custom/Utils/ListFilterOptions";

// same three lookup-driven "smart filters" the master lists use, so the
// dropdowns here are sourced identically to the listing screens
const REPORT_FILTER_CONFIG = [
  ITEM_GMDS_CODE_FILTER,
  ITEM_DESCRIPTION_FILTER,
  DISPATCHED_SERIAL_NO_FILTER,
];

const DispatchReport = () => {
  const [filters, setFilters] = useState({
    filterType: null,
    rangeType: null,
    fromDate: "",
    toDate: "",
    statuses: [],
    technicians: [],
  });

  const [errors, setErrors] = useState({});
  const [loadingData, setLoadingData] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [showReport, setShowReport] = useState(false);
  const [technicianOptions, setTechnicianOptions] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);

  // GMDS Code / Item Description / Serial No filters, sourced exactly like
  // the master lists (see REPORT_FILTER_CONFIG above)
  const {
    filters: reportFilters,
    filterValues: reportFilterValues,
    handleFilterChange: handleReportFilterChange,
    resetFilters: resetReportFilters,
    appliedFilterCount: reportAppliedFilterCount,
  } = useListFilters(REPORT_FILTER_CONFIG);

  /* ---------- OPTIONS ---------- */

  const filterOptions = [
    { value: "TODAY REPAIRED", label: "Today Repaired" },
    { value: "BY ENGINEER", label: "By Engineer" },
    { value: "CUSTOM RANGE", label: "Custom Range" },
  ];

  const rangeOptions = [
    { value: "TODAY", label: "Today" },
    { value: "YESTERDAY", label: "Yesterday" },
    { value: "LAST7", label: "Last 7 Days" },
    { value: "MONTH", label: "This Month" },
    { value: "MANUAL", label: "Manual Range" },
  ];

  const statusOptions = [
    { value: -1, label: "All" },
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Scrap", label: "Scrap" },
    { value: "Scrap Approved", label: "Scrap Approved" },
    { value: "Repair Completed", label: "Repair Completed" },
    { value: "Dispatched", label: "Dispatched" },
    { value: "Invoice Completed", label: "Invoice Completed" },
    { value: "Courier Completed", label: "Courier Completed" },
  ];

  const HRow = ({ label, value }) => {
    if (value === null || value === undefined || value === "") return null;
    return (
      <div style={{ fontSize: "0.78rem", minWidth: 160, marginBottom: 4 }}>
        <span className="text-muted">{label}: </span>
        <span className="fw-medium">{value}</span>
      </div>
    );
  };
  useEffect(() => {
    getTechnicains();
  }, []);
  const getStatusColor = (status) => {
    switch (status) {
      case "Dispatched":
        return "warning";
      case "Repair Completed":
        return "info";
      case "Approved":
        return "primary";
      case "Pending":
        return "warning";
      case "Scrap":
      case "Scrap Approved":
        return "danger";
      default:
        return "secondary";
    }
  };

  const boolBadge = (val) => {
    if (val === true)
      return <span className="text-success fw-semibold">✔ Yes</span>;
    if (val === false)
      return <span className="text-danger fw-semibold">✘ No</span>;
    return null;
  };
  const InfoRow = ({ label, value }) => {
    if (value === null || value === undefined || value === "") return null;
    return (
      <div
        className="d-flex justify-content-between mb-1"
        style={{
          fontSize: "0.78rem",
          borderBottom: "1px solid #f0f0f0",
          paddingBottom: 3,
        }}
      >
        <span className="text-muted" style={{ minWidth: 115, flexShrink: 0 }}>
          {label}
        </span>
        <span className="text-end ms-2" style={{ wordBreak: "break-word" }}>
          {value}
        </span>
      </div>
    );
  };
  const getTechnicains = async () => {
    try {
      const response = await fetch(`${apiUrl}/getTechnicianList`);
      const data = await response.json();

      const options = [
        { value: -1, label: "All" },
        ...data.data.map((t) => ({
          value: t.id,
          label: t.full_name,
        })),
      ];

      setTechnicianOptions(options);
    } catch (error) {
      console.log(error);
    }
  };

  /* ---------- VALIDATION ---------- */

  const validate = () => {
    const err = {};

    if (!filters.filterType) err.filterType = "Report Type is required";

    if (filters.filterType?.value === "CUSTOM RANGE" && !filters.rangeType)
      err.rangeType = "Date range is required";

    if (!filters.fromDate) err.fromDate = "From Date is required";
    if (!filters.toDate) err.toDate = "To Date is required";

    if (filters.statuses.length === 0) err.statuses = "Status is required";

    if (
      filters.filterType?.value === "BY ENGINEER" &&
      filters.technicians.length === 0
    )
      err.technicians = "Engineer is required";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  /* ---------- HANDLERS ---------- */

  const handleFilterTypeSelect = (option) => {
    setShowReport(false);

    const today = new Date().toISOString().split("T")[0];

    setErrors({
      filterType: null,
      statuses: null,
      technicians: null,
      fromDate: null,
      toDate: null,
    });

    setFilters({
      filterType: option,
      rangeType: null,
      fromDate: option.value === "TODAY REPAIRED" ? today : "",
      toDate: option.value === "TODAY REPAIRED" ? today : "",
      statuses:
        option.value === "TODAY REPAIRED"
          ? [{ value: "Repair Completed", label: "Repair Completed" }]
          : [],
      technicians:
        option.value === "TODAY REPAIRED" || option.value === "CUSTOM RANGE"
          ? [{ value: -1, label: "All" }]
          : [],
    });
  };

  const handleRangeSelect = (option) => {
    setShowReport(false);

    const today = new Date();
    let start = today;
    let end = today;

    if (option.value === "TODAY") start = end = new Date();
    if (option.value === "YESTERDAY")
      start = end = new Date(today.setDate(today.getDate() - 1));
    if (option.value === "LAST7") {
      start = new Date(today.setDate(today.getDate() - 6));
      end = new Date();
    }
    if (option.value === "MONTH") {
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      end = new Date();
    }

    setFilters((prev) => ({
      ...prev,
      rangeType: option,
      fromDate: start.toISOString().split("T")[0],
      toDate: end.toISOString().split("T")[0],
    }));

    setErrors((prev) => ({ ...prev, rangeType: null }));
  };

  // Runs the report with the main form's current values, plus the GMDS /
  // Item Description / Serial No filters that live inside the Report
  // Details section itself (see reportFilterOverrides below - passed
  // explicitly since state from the dropdown that just changed isn't
  // committed yet at the point it fires the refetch).
  const runReport = async (reportFilterOverrides = {}) => {
    const payload = {
      filterType: filters.filterType?.value,
      from: filters.fromDate,
      to: filters.toDate,
      statuses: filters.statuses.map((s) => s.value),
      technicians: filters.technicians.map((t) => t.value),
      gmdsCode: reportFilterValues?.gmds_code?.value || null,
      itemDescription: reportFilterValues?.descriptions?.value || null,
      serialNumber: reportFilterValues?.material_serial_no?.value || null,
      ...reportFilterOverrides,
    };

    setLoadingData(true);

    try {
      const res = await getRecords(payload, "/jobCardReport");
      setReportData(res?.data || []);
      setShowReport(true);
    } catch {
      toast.error("Failed to load report");
    } finally {
      setLoadingData(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    // a fresh GO starts a new report session - the GMDS/Description/Serial
    // No filters belong to that session, so they reset here
    resetReportFilters();
    runReport({ gmdsCode: null, itemDescription: null, serialNumber: null });
  };

  // GMDS / Item Description / Serial No filters inside Report Details -
  // auto-apply immediately, same as the master list filter bars
  const handleReportFilterSelect = (key, payloadKey, option) => {
    handleReportFilterChange(key, option);
    runReport({ [payloadKey]: option?.value || null });
  };

  // const getDateValue = (row) => {
  //   const filterType = filters.filterType?.value;

  //   if (filterType === "TODAY REPAIRED") {
  //     return formatDate(row?.repair_completed_date);
  //   }

  //   if (filterType === "BY ENGINEER" || filterType === "CUSTOM RANGE") {
  //     if (row?.status === "Repair Completed") {
  //       return formatDate(row?.repair_completed_date);
  //     }
  //     if (row?.status === "Dispatched") {
  //       return formatDate(row?.dispatched_date);
  //     }
  //   }

  //   return formatDate(row?.createdAt);
  // };

  // const getDateColumnName = () => {
  //   const filterType = filters.filterType?.value;
  //   const statuses = filters.statuses?.map((s) => s.value) || [];

  //   if (filterType === "TODAY REPAIRED") return "Repair Completed Date";

  //   if (filterType === "BY ENGINEER" || filterType === "CUSTOM RANGE") {
  //     if (statuses.includes("Repair Completed")) return "Repair Completed Date";
  //     if (statuses.includes("Dispatched")) return "Dispatched Date";
  //   }

  //   return "Created Date";
  // };
  const getOnlyDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    if (isNaN(d.getTime())) return "-";

    return d
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");
  };

  const getDateValue = (row) => {
    const filterType = filters.filterType?.value;

    if (filterType === "TODAY REPAIRED") {
      return getOnlyDate(row?.repair_completed_date);
    }

    if (filterType === "BY ENGINEER" || filterType === "CUSTOM RANGE") {
      if (row?.status === "Repair Completed") {
        return getOnlyDate(row?.repair_completed_date);
      }
      // Invoice Completed → invoice createdAt
      if (row?.status === "Dispatched" && row?.invoice?.status == 1) {
        return getOnlyDate(row?.invoice?.createdAt);
      }
      // Courier Completed → invoice updatedAt
      if (row?.status === "Dispatched" && row?.invoice?.status == 2) {
        return getOnlyDate(row?.invoice?.updatedAt);
      }
      if (row?.status === "Dispatched") {
        return getOnlyDate(row?.dispatched_date);
      }
    }

    return getOnlyDate(row?.updatedAt);
  };

  const getDateColumnName = () => {
    const filterType = filters.filterType?.value;
    const statuses = filters?.statuses?.map((s) => s.value) || [];

    if (filterType === "TODAY REPAIRED") return "Repair Completed Date";

    if (filterType === "BY ENGINEER" || filterType === "CUSTOM RANGE") {
      if (statuses.length === 1) {
        if (statuses.includes("Repair Completed"))
          return "Repair Completed Date";
        if (statuses.includes("Dispatched")) return "Dispatched Date";
        if (statuses.includes("Invoice Completed"))
          return "Invoice Completed Date";
        if (statuses.includes("Courier Completed"))
          return "Courier Completed Date";
      }

      if (statuses.length > 1) return "Created Date";
    }

    return "Created Date";
  };
  const exportToExcel = async () => {
    const response = await fetch(`${baseURL}api/export/job-card-report`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        filterType: filters.filterType?.value,
        from: filters.fromDate,
        to: filters.toDate,
        statuses: filters.statuses.map((s) => s.value),
        technicians: filters.technicians.map((t) => t.value),
        gmdsCode: reportFilterValues?.gmds_code?.value || null,
        itemDescription: reportFilterValues?.descriptions?.value || null,
        serialNumber: reportFilterValues?.material_serial_no?.value || null,
      }),
    });

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "dispatch_report.xlsx";
    a.click();
  };

  /* ---------- UI ---------- */

  return (
    <div className="page-content">
      <Breadcrumbs title="History Report - (Job Card)" breadcrumbItems={[]} />

      <div className="card p-4 mb-3">
        <form onSubmit={handleSubmit}>
          <Row className="gx-3 gy-3">
            <Col md={4}>
              <SelectInput
                label="Report Type"
                options={filterOptions}
                placeholder="Report type"
                value={filters.filterType}
                onSelect={handleFilterTypeSelect}
                customError={errors.filterType}
                asterisk={true}
              />
            </Col>

            {filters.filterType?.value === "BY ENGINEER" && (
              <Col md={4}>
                <MultiSelectInput
                  label="Engineer"
                  options={technicianOptions}
                  value={filters.technicians}
                  placeholder="Select Engineer"
                  onMultiSelect={(selected) => {
                    setShowReport(false);

                    if (selected.some((s) => s.value === -1)) {
                      setFilters({
                        ...filters,
                        technicians: [{ value: -1, label: "All" }],
                      });
                    } else {
                      setFilters({ ...filters, technicians: selected });
                    }

                    setErrors((prev) => ({ ...prev, technicians: null }));
                  }}
                  customError={errors.technicians}
                  asterisk
                />
              </Col>
            )}

            {filters.filterType?.value === "CUSTOM RANGE" && (
              <Col md={4}>
                <SelectInput
                  label="Date Range"
                  options={rangeOptions}
                  placeholder="Select date range"
                  value={filters.rangeType}
                  onSelect={handleRangeSelect}
                  asterisk={true}
                  customError={errors.rangeType}
                />
              </Col>
            )}

            {(filters.rangeType?.value === "MANUAL" ||
              filters.filterType?.value !== "CUSTOM RANGE") && (
              <>
                <Col md={4}>
                  <TextInput
                    label="From Date"
                    type="date"
                    value={filters.fromDate}
                    readOnly={filters.filterType?.value === "TODAY REPAIRED"}
                    placeholder="Select from date"
                    onChange={(e) => {
                      setShowReport(false);

                      setFilters({ ...filters, fromDate: e.target.value });
                      setErrors((prev) => ({ ...prev, fromDate: null }));
                    }}
                    customError={errors.fromDate}
                    asterisk={true}
                  />
                </Col>

                <Col md={4}>
                  <TextInput
                    label="To Date"
                    type="date"
                    min={filters.fromDate}
                    value={filters.toDate}
                    readOnly={filters.filterType?.value === "TODAY REPAIRED"}
                    placeholder="Select to date"
                    onChange={(e) => {
                      setShowReport(false);

                      setFilters({ ...filters, toDate: e.target.value });
                      setErrors((prev) => ({ ...prev, toDate: null }));
                    }}
                    customError={errors.toDate}
                    asterisk={true}
                  />
                </Col>
              </>
            )}

            <Col md={4}>
              <MultiSelectInput
                label="Status"
                options={statusOptions}
                value={filters.statuses}
                placeholder="Select status"
                disabled={filters.filterType?.value === "TODAY REPAIRED"}
                onMultiSelect={(selected) => {
                  setShowReport(false);
                  if (selected.some((s) => s.value === -1)) {
                    // show only All in UI
                    setFilters({
                      ...filters,
                      statuses: [{ value: -1, label: "All" }],
                    });
                  } else {
                    setFilters({ ...filters, statuses: selected });
                  }

                  setErrors((prev) => ({ ...prev, statuses: null }));
                }}
                customError={errors.statuses}
                asterisk
              />
            </Col>

            <Col md={4} className="d-flex align-items-end">
              <button className="btn btn-primary">GO</button>
            </Col>
          </Row>
        </form>
      </div>

      {loadingData && (
        <div style={loaderOverlay}>
          <LoaderCreatePage />
        </div>
      )}

      {showReport && (
        <div className="card">
          <div className="card-body">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="card-title mb-0">Report Details</h5>
              <button
                type="button"
                className="btn btn-success btn-sm d-flex align-items-center gap-1"
                onClick={exportToExcel}
              >
                <Download size={14} />
                &nbsp;Export To Excel
              </button>
            </div>

            {/* GMDS Code / Item Description / Serial No - narrow this
                report's results, same lookup-driven dropdowns and
                auto-apply-on-change behaviour as the master list filters */}
            <div className="d-flex flex-wrap align-items-end gap-3 mb-3">
              <div style={{ minWidth: 220 }}>
                <SelectInput
                  label="GMDS Code"
                  options={
                    reportFilters.find((f) => f.key === "gmds_code")?.options
                  }
                  value={reportFilterValues?.gmds_code}
                  onSelect={(option) =>
                    handleReportFilterSelect("gmds_code", "gmdsCode", option)
                  }
                  placeholder="Select GMDS Code"
                  isClearable={true}
                />
              </div>

              <div style={{ minWidth: 220 }}>
                <SelectInput
                  label="Item Description"
                  options={
                    reportFilters.find((f) => f.key === "descriptions")
                      ?.options
                  }
                  value={reportFilterValues?.descriptions}
                  onSelect={(option) =>
                    handleReportFilterSelect(
                      "descriptions",
                      "itemDescription",
                      option,
                    )
                  }
                  placeholder="Select Item Description"
                  isClearable={true}
                />
              </div>

              <div style={{ minWidth: 220 }}>
                <SelectInput
                  label="Serial No"
                  options={
                    reportFilters.find(
                      (f) => f.key === "material_serial_no",
                    )?.options
                  }
                  value={reportFilterValues?.material_serial_no}
                  onSelect={(option) =>
                    handleReportFilterSelect(
                      "material_serial_no",
                      "serialNumber",
                      option,
                    )
                  }
                  placeholder="Select Serial No"
                  isClearable={true}
                />
              </div>

              {reportAppliedFilterCount > 0 && (
                <button
                  type="button"
                  className="btn btn-link p-0 text-decoration-none mb-2"
                  style={{ color: "#f9992d", fontWeight: 600 }}
                  onClick={() => {
                    resetReportFilters();
                    runReport({
                      gmdsCode: null,
                      itemDescription: null,
                      serialNumber: null,
                    });
                  }}
                >
                  <i className="mdi mdi-filter-remove-outline me-1" />
                  Clear ({reportAppliedFilterCount})
                </button>
              )}
            </div>

            {/* Table */}
            <div
              className="table mt-2"
              style={{
                maxHeight: "450px",
                overflowY: "auto",
                width: "100%",
                scrollBehavior: "smooth",
              }}
            >
              <table className="table table-hover table-bordered fw-bold">
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f9992d",
                    zIndex: 1,
                  }}
                >
                  <tr>
                    <th>Sr No</th>
                    <th>Job Card</th>
                    <th>GMDS Code</th>
                    <th>Item Serial No</th>
                    <th>Item Description</th>
                    <th>Status</th>
                    <th>Engineer Name</th>
                    <th>{getDateColumnName()}</th>
                    <th style={{ width: 40 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.length === 0 && (
                    <tr>
                      <td colSpan={9} className="text-center text-muted py-4">
                        There are no records to display
                      </td>
                    </tr>
                  )}

                  {reportData.map((row, index) => {
                    const rowKey = `${row.id}-${row.dispatch?.id ?? "nd"}-${index}`;
                    const isOpen = expandedRow === rowKey;
                    const isDispatched = row?.status === "Dispatched";
                    const hasInvoice = !!row?.invoice;

                    // ── Derive display status for banner ──
                    let bannerLabel = row?.status;
                    let bannerIcon = isDispatched
                      ? "truck"
                      : row?.status === "Repair Completed"
                        ? "tools"
                        : row?.status === "Approved"
                          ? "check-circle"
                          : row?.status === "Scrap Approved"
                            ? "ban"
                            : row?.status === "Scrap"
                              ? "trash-alt"
                              : "clock";
                    let bannerColor = getStatusColor(row?.status);

                    if (isDispatched && hasInvoice) {
                      if (row.invoice.status === 1) {
                        bannerLabel = "Invoice Completed";
                        bannerIcon = "file-invoice";
                        bannerColor = "primary";
                      } else if (row.invoice.status === 2) {
                        bannerLabel = "Courier Completed";
                        bannerIcon = "shipping-fast";
                        bannerColor = "success";
                      }
                    }

                    return (
                      <React.Fragment key={rowKey}>
                        {/* ── Summary Row ── */}
                        <tr
                          onClick={() =>
                            setExpandedRow((prev) =>
                              prev === rowKey ? null : rowKey,
                            )
                          }
                          style={{ cursor: "pointer" }}
                          className={isOpen ? "table-primary" : ""}
                        >
                          <td>{index + 1}</td>
                          <td>
                            <strong>{row?.job_card_no}</strong>
                          </td>
                          <td>
                            {row?.intake?.material?.gmds_code ||
                              row?.intake?.material?.name ||
                              "—"}
                          </td>
                          <td>{row?.intake?.material_serial_no || "—"}</td>
                          <td>{row?.intake?.material?.descriptions || "—"}</td>
                          <td>
                            {/* Show invoice/courier status in table badge if dispatched */}
                            <span
                              className={`badge badge-soft-${
                                isDispatched && hasInvoice
                                  ? row.invoice.status === 2
                                    ? "success"
                                    : row.invoice.status === 1
                                      ? "primary"
                                      : getStatusColor(row?.status)
                                  : getStatusColor(row?.status)
                              }`}
                              style={{ fontSize: "0.75rem" }}
                            >
                              {isDispatched && hasInvoice
                                ? row.invoice.status === 2
                                  ? "Courier Completed"
                                  : row.invoice.status === 1
                                    ? "Invoice Completed"
                                    : row?.status
                                : row?.status}
                            </span>
                          </td>
                          <td>{row?.technician?.full_name || "—"}</td>

                          <td>{getDateValue(row)}</td>
                          <td className="text-center">
                            <i
                              className={`fas fa-chevron-${isOpen ? "up" : "down"} text-muted`}
                            />
                          </td>
                        </tr>

                        {/* ── Expanded Row ── */}
                        {isOpen && (
                          <tr>
                            <td
                              colSpan={9}
                              style={{
                                background: "#ebfaeb",
                                borderTop: "2px solid #556ee6",
                                padding: 0,
                              }}
                            >
                              <div style={{ padding: "14px 16px" }}>
                                {/* ── Status Banner ── */}
                                <div
                                  className={`alert alert-${bannerColor} d-flex align-items-center gap-2 py-2 mb-2`}
                                >
                                  <i className={`fas fa-${bannerIcon}`} />
                                  <strong>Current Status: {bannerLabel}</strong>
                                  {/* {isDispatched && row?.dispatched_date && (
                                    <span
                                      className="ms-2"
                                      style={{
                                        fontSize: "0.82rem",
                                        opacity: 0.8,
                                      }}
                                    >
                                      — Dispatched on{" "}
                                      {formatDate(row?.dispatched_date)}
                                    </span>
                                  )} */}
                                </div>

                                {/* ── 1. Intake Details — always shown ── */}
                                <div
                                  className="card mb-2 shadow-sm"
                                  style={{ borderLeft: "4px solid #34c38f" }}
                                >
                                  <div className="card-body p-2">
                                    <h6
                                      className="text-success mb-2"
                                      style={{ fontSize: "0.82rem" }}
                                    >
                                      <i className="fas fa-box-open me-1" />
                                      Intake Details
                                    </h6>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "0 24px",
                                      }}
                                    >
                                      <HRow
                                        label="GMDS Code"
                                        value={
                                          row?.intake?.material?.gmds_code ||
                                          row?.intake?.material?.name
                                        }
                                      />
                                      <HRow
                                        label="Serial No"
                                        value={row?.intake?.material_serial_no}
                                      />
                                      <HRow
                                        label="Intake No"
                                        value={row?.intake?.intake_no}
                                      />
                                      <HRow
                                        label="Received Date"
                                        value={formatDate(
                                          row?.intake?.received_date,
                                        )}
                                      />
                                      <HRow
                                        label="Issue"
                                        value={row?.intake?.issue_descriptions}
                                      />
                                      <HRow
                                        label="Comments"
                                        value={row?.intake?.comments}
                                      />
                                      <HRow
                                        label="Anti Static Bag"
                                        value={boolBadge(
                                          row?.intake?.anti_static_bag,
                                        )}
                                      />
                                      <HRow
                                        label="Fault Tag"
                                        value={boolBadge(
                                          row?.intake?.fault_tag_attached,
                                        )}
                                      />
                                      <HRow
                                        label="Invoice Match"
                                        value={boolBadge(
                                          row?.intake?.items_matching_invoice,
                                        )}
                                      />
                                      <HRow
                                        label="Repairable"
                                        value={boolBadge(
                                          row?.intake?.is_repairable,
                                        )}
                                      />
                                      {row?.intake
                                        ?.fault_reported_from_field && (
                                        <HRow
                                          label="Fault (Field)"
                                          value={
                                            row?.intake
                                              ?.fault_reported_from_field
                                          }
                                        />
                                      )}
                                      {row?.intake?.rate_per_unit && (
                                        <HRow
                                          label="Rate / Unit"
                                          value={`₹ ${row?.intake?.rate_per_unit}`}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {/* ── 2. Job Card Info — always shown ── */}
                                <div
                                  className="card mb-2 shadow-sm"
                                  style={{ borderLeft: "4px solid #556ee6" }}
                                >
                                  <div className="card-body p-2">
                                    <h6
                                      className="text-primary mb-2"
                                      style={{ fontSize: "0.82rem" }}
                                    >
                                      <i className="fas fa-clipboard-list me-1" />
                                      Job Card Info
                                    </h6>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "0 24px",
                                      }}
                                    >
                                      <HRow
                                        label="Job Card No"
                                        value={
                                          <strong>{row?.job_card_no}</strong>
                                        }
                                      />

                                      <HRow
                                        label="Engineer"
                                        value={
                                          row?.technician?.full_name ?? "—"
                                        }
                                      />
                                      <HRow
                                        label="Created At"
                                        value={formatDate(row?.createdAt)}
                                      />

                                      <HRow
                                        label="Engineer Checked At"
                                        value={formatDate(
                                          row?.technician_check_at,
                                        )}
                                      />

                                      <HRow
                                        label="Check Remark"
                                        value={row?.technician_check_remark}
                                      />
                                      <HRow
                                        label="Repairable"
                                        value={boolBadge(
                                          row?.technician_check_is_repairable,
                                        )}
                                      />

                                      {row?.technician_custom_reason && (
                                        <HRow
                                          label="Scrap Reason"
                                          value={row?.technician_custom_reason}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {/* ── 3. Repair Info — only when Dispatched ── */}
                                {isDispatched && (
                                  <div
                                    className="card mb-2 shadow-sm"
                                    style={{
                                      borderLeft: "4px solid #f1b44c",
                                      background: "#fff",
                                    }}
                                  >
                                    <div className="card-body p-2">
                                      <h6
                                        className="text-warning mb-2"
                                        style={{ fontSize: "0.82rem" }}
                                      >
                                        <i className="fas fa-tools me-1" />
                                        Repair Info
                                      </h6>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: "0 24px",
                                        }}
                                      >
                                        <HRow
                                          label="Repair Completed"
                                          value={formatDate(
                                            row?.repair_completed_date,
                                          )}
                                        />
                                        <HRow
                                          label="Repair Remark"
                                          value={row?.repair_check_remark}
                                        />
                                        <HRow
                                          label="Component"
                                          value={row?.component_replaced}
                                        />
                                        <HRow
                                          label="Ref No 1"
                                          value={row?.component_reference_no_1}
                                        />
                                        <HRow
                                          label="Ref No 2"
                                          value={row?.component_reference_no_2}
                                        />
                                        <HRow
                                          label="Ref No 3"
                                          value={row?.component_reference_no_3}
                                        />
                                        <HRow
                                          label="Item Code"
                                          value={row?.component_item_code_no}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* ── 4. Dispatch Info — only when dispatch object exists ── */}
                                {isDispatched && row?.dispatch && (
                                  <div
                                    className="card mb-2 shadow-sm"
                                    style={{
                                      borderLeft: "4px solid #f46a6a",
                                      background: "#fff",
                                    }}
                                  >
                                    <div className="card-body p-2">
                                      <h6
                                        className="text-danger mb-2"
                                        style={{ fontSize: "0.82rem" }}
                                      >
                                        <i className="fas fa-truck me-1" />
                                        Dispatch Info
                                      </h6>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: "0 24px",
                                        }}
                                      >
                                        <HRow
                                          label="Dispatched Date"
                                          value={
                                            <strong className="text-success">
                                              {formatDate(row?.dispatched_date)}
                                            </strong>
                                          }
                                        />
                                        <HRow
                                          label="Dispatch No"
                                          value={row.dispatch.dispatched_no}
                                        />
                                        <HRow
                                          label="Dispatched By"
                                          value={
                                            row.dispatch.dispatched_by_user
                                              ?.full_name
                                          }
                                        />
                                        <HRow
                                          label="Remark"
                                          value={row.dispatch.remark}
                                        />
                                        <HRow
                                          label="Invoice Generated"
                                          value={boolBadge(
                                            row.dispatch.is_invoice_generated,
                                          )}
                                        />
                                      </div>
                                      {row.dispatch.is_invoice_generated !==
                                        true && (
                                        <div
                                          className="mt-2 p-2 rounded"
                                          style={{
                                            background: "#fff3cd",
                                            fontSize: "0.78rem",
                                          }}
                                        >
                                          <i className="fas fa-hourglass-half me-1 text-warning" />
                                          Awaiting Invoice Generation.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}

                                {/* ── 5. Invoice Info — only when invoice exists ── */}
                                {isDispatched && hasInvoice && (
                                  <div
                                    className="card mb-2 shadow-sm"
                                    style={{
                                      borderLeft: "4px solid #6f42c1",
                                      background: "#fff",
                                    }}
                                  >
                                    <div className="card-body p-2">
                                      <h6
                                        className="mb-2"
                                        style={{
                                          fontSize: "0.82rem",
                                          color: "#6f42c1",
                                        }}
                                      >
                                        <i className="fas fa-file-invoice me-1" />
                                        Invoice Info
                                      </h6>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: "0 24px",
                                        }}
                                      >
                                        <HRow
                                          label="Invoice No"
                                          value={
                                            <strong>
                                              {row.invoice.invoice_number}
                                            </strong>
                                          }
                                        />
                                        <HRow
                                          label="Branch"
                                          value={
                                            row.invoice.branch?.branch_name
                                          }
                                        />
                                        <HRow
                                          label="Zone"
                                          value={row.invoice.zone?.zone_name}
                                        />
                                        <HRow
                                          label="Created By"
                                          value={
                                            row.invoice.created_user?.full_name
                                          }
                                        />
                                        <HRow
                                          label="Created At"
                                          value={formatDate(
                                            row.invoice.createdAt,
                                          )}
                                        />
                                      </div>
                                      {row.invoice.status === 1 && (
                                        <div
                                          className="mt-2 p-2 rounded"
                                          style={{
                                            background: "#fff3cd",
                                            fontSize: "0.78rem",
                                          }}
                                        >
                                          <i className="fas fa-info-circle me-1 text-warning" />
                                          Invoice completed. Awaiting Courier
                                          Completion.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}

                                {/* ── 6. Courier Info — only when invoice status is 2 ── */}
                                {isDispatched &&
                                  hasInvoice &&
                                  row.invoice.status === 2 && (
                                    <div
                                      className="card mb-2 shadow-sm"
                                      style={{
                                        borderLeft: "4px solid #20c997",
                                        background: "#fff",
                                      }}
                                    >
                                      <div className="card-body p-2">
                                        <h6
                                          className="mb-2"
                                          style={{
                                            fontSize: "0.82rem",
                                            color: "#20c997",
                                          }}
                                        >
                                          <i className="fas fa-shipping-fast me-1" />
                                          Courier Info
                                        </h6>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "0 24px",
                                          }}
                                        >
                                          <HRow
                                            label="Courier"
                                            value={row.invoice.courier_name}
                                          />
                                          <HRow
                                            label="Docket No"
                                            value={
                                              row.invoice.courier_docket_number
                                            }
                                          />
                                          <HRow
                                            label="Docket Date"
                                            value={formatDate(
                                              row.invoice.courier_docket_date,
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                {/* ── Status Info — only for non-dispatched ── */}
                                {!isDispatched && (
                                  <div
                                    className="card mb-2 shadow-sm"
                                    style={{
                                      borderLeft: `4px solid var(--bs-${getStatusColor(row?.status)})`,
                                    }}
                                  >
                                    <div className="card-body p-2">
                                      <h6
                                        className={`text-${getStatusColor(row?.status)} mb-2`}
                                        style={{ fontSize: "0.82rem" }}
                                      >
                                        <i
                                          className={`fas fa-${
                                            row?.status === "Repair Completed"
                                              ? "tools"
                                              : row?.status === "Approved"
                                                ? "check-circle"
                                                : row?.status ===
                                                    "Scrap Approved"
                                                  ? "ban"
                                                  : row?.status === "Scrap"
                                                    ? "trash-alt"
                                                    : "clock"
                                          } me-1`}
                                        />
                                        {row?.status} Info
                                      </h6>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: "0 24px",
                                        }}
                                      >
                                        {row?.status === "Repair Completed" && (
                                          <>
                                            <HRow
                                              label="Repair Completed"
                                              value={formatDate(
                                                row?.repair_completed_date,
                                              )}
                                            />
                                            <HRow
                                              label="Repair Remark"
                                              value={row?.repair_check_remark}
                                            />
                                            <HRow
                                              label="Component"
                                              value={row?.component_replaced}
                                            />
                                            <HRow
                                              label="Component Ref No 1"
                                              value={
                                                row?.component_reference_no_1
                                              }
                                            />
                                            <HRow
                                              label="Component Ref No 2"
                                              value={
                                                row?.component_reference_no_2
                                              }
                                            />
                                            <HRow
                                              label="Component Ref No 3"
                                              value={
                                                row?.component_reference_no_3
                                              }
                                            />
                                            <HRow
                                              label="Component Item Code"
                                              value={
                                                row?.component_item_code_no
                                              }
                                            />
                                          </>
                                        )}
                                        {row?.status === "Approved" && (
                                          <>
                                            <HRow
                                              label="Checked At"
                                              value={formatDate(
                                                row?.technician_check_at,
                                              )}
                                            />
                                            <HRow
                                              label="Check Remark"
                                              value={
                                                row?.technician_check_remark
                                              }
                                            />
                                            <HRow
                                              label="Component"
                                              value={row?.component_replaced}
                                            />
                                            <HRow
                                              label="Ref No 1"
                                              value={
                                                row?.component_reference_no_1
                                              }
                                            />
                                            <HRow
                                              label="Ref No 2"
                                              value={
                                                row?.component_reference_no_2
                                              }
                                            />
                                            <HRow
                                              label="Ref No 3"
                                              value={
                                                row?.component_reference_no_3
                                              }
                                            />
                                            <HRow
                                              label="Item Code"
                                              value={
                                                row?.component_item_code_no
                                              }
                                            />
                                          </>
                                        )}
                                        {(row?.status === "Scrap" ||
                                          row?.status === "Scrap Approved") && (
                                          <>
                                            <HRow
                                              label="Scrap Reason"
                                              value={
                                                row?.technician_custom_reason
                                              }
                                            />
                                            <HRow
                                              label="Check Remark"
                                              value={
                                                row?.technician_check_remark
                                              }
                                            />
                                            {row.status === "Scrap" && (
                                              <HRow
                                                label="Checked At"
                                                value={formatDate(
                                                  row?.technician_check_at,
                                                )}
                                              />
                                            )}
                                            {row.status ===
                                              "Scrap Approved" && (
                                              <HRow
                                                label="Scrap Approved At"
                                                value={formatDate(
                                                  row?.updatedAt,
                                                )}
                                              />
                                            )}
                                          </>
                                        )}
                                        {row?.status === "Pending" && (
                                          <>
                                            <HRow
                                              label="Assigned At"
                                              value={formatDate(row?.createdAt)}
                                            />
                                            <HRow
                                              label="Check Remark"
                                              value={
                                                row?.technician_check_remark
                                              }
                                            />
                                          </>
                                        )}
                                      </div>

                                      {/* info notes */}
                                      {row?.status === "Repair Completed" && (
                                        <div
                                          className="mt-2 p-2 rounded"
                                          style={{
                                            background: "#fff3cd",
                                            fontSize: "0.78rem",
                                          }}
                                        >
                                          <i className="fas fa-info-circle me-1 text-warning" />
                                          Repair completed. Awaiting dispatch.
                                        </div>
                                      )}
                                      {row?.status === "Approved" && (
                                        <div
                                          className="mt-2 p-2 rounded"
                                          style={{
                                            background: "#cce5ff",
                                            fontSize: "0.78rem",
                                          }}
                                        >
                                          <i className="fas fa-info-circle me-1 text-primary" />
                                          Approved for repair. Work in progress.
                                        </div>
                                      )}
                                      {(row?.status === "Scrap" ||
                                        row?.status === "Scrap Approved") && (
                                        <div
                                          className="mt-2 p-2 rounded"
                                          style={{
                                            background: "#f8d7da",
                                            fontSize: "0.78rem",
                                          }}
                                        >
                                          <i className="fas fa-exclamation-triangle me-1 text-danger" />
                                          {row?.status === "Scrap"
                                            ? "Marked as scrap. Awaiting approval."
                                            : "Scrap approved. Item will not be repaired."}
                                        </div>
                                      )}
                                      {row?.status === "Pending" && (
                                        <div
                                          className="mt-2 p-2 rounded"
                                          style={{
                                            background: "#fff3cd",
                                            fontSize: "0.78rem",
                                          }}
                                        >
                                          <i className="fas fa-hourglass-half me-1 text-warning" />
                                          Pending — awaiting engineer action.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DispatchReport;
